const selectBureauForm = state => state.bureauForm;

export const selectBureauFormClientDetail = state =>
  selectBureauForm(state).clientDetail;

export const selectBureauFormQuoteDetail = state =>
  selectBureauForm(state).quoteDetail;

export const selectBureauFormResult = state =>
  selectBureauForm(state).formResult;

export const selectBureauFormTokenData = state =>
  selectBureauForm(state).tokenData;

export const selectBureauFormTokenValidationStatus = state =>
  selectBureauForm(state).tokenValidationStatus;

export const selectBureauFormId = state => selectBureauForm(state).formId;
